<main>
  <loading-overlay [isLoading]="isLoading() > 0" [fullWidth]="true"></loading-overlay>
  <p-toast position="bottom-right" key="br"></p-toast>

  <header>
    <div class="headline">
      <h1>{{ headerTitle }}</h1>
      <csl-dropdown [formControl]="status" [enumObject]="statusEnumObject" [enumValueOptions]="knittingOrderStatusOptions"> </csl-dropdown>
    </div>
    <div class="buttons">
      <p-button severity="secondary" icon="pi pi-print" (click)="getKnittingOrderReport()" />
      <span class="separator"></span>
      <p-splitbutton label="Save" (onClick)="saveKnittingOrder(false)" [disabled]="blockSections()" [model]="saveMenuItems" />
      <p-button label="Cancel" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    <div class="grid-12">
      <div class="span-12-6-4">
        <p-panel [header]="'Knitting_Order_Details_Panel_Details' | translateWF: 'Knitting Order Details'">
          <ng-template pTemplate="icons">
            <p-button severity="info" [label]="'Knitting_Order_Details_Related_Info' | translateWF: 'Related Info'" (click)="viewSiblingKnittingOrderModal()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#ffffff" d="M21.66 6.423L12 .845L2.34 6.423v11.154L12 23.155l9.66-5.578zM12 16a4 4 0 1 1 0-8a4 4 0 0 1 0 8" />
              </svg>
            </p-button>
          </ng-template>

          <p-card>
            <div class="col">
              <div class="form-box">
                <label for="">
                  {{ 'workOrder' | translateWF: 'Work Order' }}
                </label>
                @if (!originalKnittingOrder?.id) {
                  <p-autocomplete
                    fluid
                    [dropdown]="true"
                    [formControl]="workOrder"
                    #workOrderSearch="cslServerSearch"
                    [cslServerSearch]="fetchWorkOrders"
                    [suggestions]="workOrderSearch.results()"
                    optionLabel="orderNumber"
                    class="w-full"
                    [forceSelection]="true"
                  />
                } @else {
                  <input pInputText type="text" class="w-full min-w-[12rem]" [value]="workOrder.value?.orderNumber" [disabled]="true" />
                }
              </div>
              <div class="form-box">
                <label for=""> {{ 'Knitting_Order_Details_Work_Location' | translateWF: 'Work Location' }} </label>
                @if (!originalKnittingOrder?.id) {
                  <p-select fluid [formControl]="location" [options]="locationOptions" class="w-full" />
                } @else {
                  <input pInputText type="text" class="w-full min-w-[12rem]" [value]="getLocationName(location.value!)" [disabled]="true" />
                }
              </div>
              <div class="form-box">
                <label for="">
                  {{ 'Knitting_Order_Details_Work_Order_Type' | translateWF: 'Work Order Type' }}
                </label>
                <!-- [value]="workOrderTypes[workOrder.value?.orderType]" -->
                <input [value]="workOrder.value && workOrderTypes[workOrder.value.orderType]" pInputText optionLabel="orderType" class="w-full" [disabled]="workOrder" />
              </div>
              <div class="form-box">
                <label for="">
                  {{ 'Knitting_Order_Details_Work_Order_Term' | translateWF: 'Work Order Term' }}
                </label>
                <input [value]="workOrder.value && workOrderTerms[workOrder.value.workOrderTerm]" pInputText optionLabel="orderType" class="w-full" [disabled]="workOrder" />
              </div>
            </div>
          </p-card>
        </p-panel>
      </div>
      <div class="col span-12-6-8">
        <div class="row-end-center">
          <p-button [label]="'Knitting_Order_Details_Add_New_Requisition' | translateWF: 'Add New Requisition'" (click)="createNewRequisition()" [disabled]="blockSections()" />
        </div>
        @if (userLite) {
          <p-panel header="Notes">
            <csl-standard-notes [userLite]="userLite" [notes]="notes" (viewMore)="onViewMore()" />
          </p-panel>
        }
      </div>
    </div>

    @if (isGreigeOnlyOrder) {
      <div class="p-3 mb-4 border-round surface-100 text-color-secondary">
        <i class="pi pi-info-circle mr-2"></i>
        {{
          'Knitting_Order_Details_Greige_Only_Message'
            | translateWF
              : 'This is a Greige Only Work Order. Production
      Cards are not allowed. Knitting loss calculation uses only Knitting Process Loss Percentage.'
        }}
      </div>
    }

    @if (workOrder.value && !isAnyGreigeOrder) {
      <p-panel [header]="'Knitting_Order_Details_Work_Order_Fabrics' | translateWF: 'Fabrics In Work Order'">
        <ng-template pTemplate="icons">
          <p-button
            severity="info"
            [label]="'Knitting_Order_Details_Set_Production_Cards' | translateWF: 'Set Production Cards'"
            [disabled]="blockSections()"
            (click)="viewProductionCardsModal()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path fill="#ffffff" d="M21.66 6.423L12 .845L2.34 6.423v11.154L12 23.155l9.66-5.578zM12 16a4 4 0 1 1 0-8a4 4 0 0 1 0 8" />
            </svg>
          </p-button>
        </ng-template>

        <p-card data-variant="compact">
          <p-table [value]="productionCardsEntriesFormArray.controls" class="table w-full">
            <ng-template #header>
              <tr class="dark__header">
                <th class="text-center">{{ 'Knitting_Order_Details_Table_Fabric' | translateWF: 'Fabric' }}</th>
                <th></th>
                <th class="text-center">
                  @if (isAnyGreigeOrder) {
                    {{ 'Knitting_Order_Details_Table_Work_Order_Qty' | translateWF: 'Work Order Qty' }}
                  } @else {
                    <span pTooltip="{{ 'Knitting_Order_Details_Tooltip_Dyeing_Planned_Qty' | translateWF: 'Work Order Qty + Dyeing Loss %' }}" tooltipPosition="top">
                      {{ 'Knitting_Order_Details_Table_Dyeing_Planned_Qty' | translateWF: 'Dyeing Planned Qty' }}
                      <i class="pi pi-info-circle ml-1 text-gray-400"></i>
                    </span>
                  }
                </th>
                <th class="text-center">
                  <span pTooltip="{{ 'Knitting_Order_Details_Tooltip_Estimated_Knitting_Qty' | translateWF: 'Dyeing Planned Qty + Knitting Loss %' }}" tooltipPosition="top">
                    {{
                      'Knitting_Order_Details_Table_Estimated_Knitting_Planning_Qty'
                        | translateWF
                          : 'Estimated Knitting
                  Planning Qty'
                    }}
                    <i class="pi pi-info-circle ml-1 text-gray-400"></i>
                  </span>
                </th>
                <th class="text-center">
                  {{ 'Knitting_Order_Details_Table_Planned_Qty' | translateWF: 'Planned Qty' }}
                </th>
                <th class="text-center">
                  {{ 'Knitting_Order_Details_Table_Programmed_Qty' | translateWF: 'Programmed Qty' }}
                </th>
                <th class="text-center">
                  {{ 'Knitting_Order_Details_Table_Issued_Qty' | translateWF: 'Issued Qty' }}
                </th>
                <th class="text-center">
                  {{ 'Knitting_Order_Details_Table_Missing_Qty' | translateWF: 'Missing Qty' }}
                </th>
              </tr>
            </ng-template>
            @if (productionCardsEntriesFormArray.controls.length > 0) {
              <ng-template #body let-pce let-rowIndex="rowIndex">
                <tr>
                  <td>
                    <b>{{ pce.value.fabricCode }}</b>
                    <p>{{ fetchFabricDescription(pce.value.fabricCode) }} - {{ fetchFabricTubularOrOpenWith(pce.value.fabricCode) }}</p>
                    <b>Greige Code: {{ fetchGreigeCode(pce.value.fabricCode) }}</b>
                    <p>Needles: {{ fetchGreigeNeedleCount(pce.value.fabricCode) | number: '1.0-0' }}</p>
                    <p>Loop Lengths: {{ getFabricLoopLengths(pce.value.fabricCode) }}</p>
                  </td>

                  <td>
                    <!-- (click)="viewFabricDetailsModal(fabric.fabric)" -->
                    <button class="border-none" (click)="viewFabricDetailsModal(pce.value.fabricCode)">
                      <span class="material-icons"> visibility </span>
                    </button>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input pInputText type="text" class="w-full" [value]="pce.value.quantity | number: '1.0-2'" [disabled]="true" />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input pInputText type="text" class="w-full" [value]="getEstimatedKnittingQuantity(pce) | number: '1.0-2'" [disabled]="true" />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input
                        pInputText
                        type="text"
                        class="w-full"
                        [value]="getCurrentPlannedQuantity(pce.value.fabricCode) | number: '1.0-2'"
                        [readOnly]="true"
                        style="background-color: #ffedd5"
                      />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input pInputText type="text" class="w-full" [value]="getFabricCodeProgrammedQuantity(pce.value.fabricCode) | number: '1.0-2'" [disabled]="true" />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input pInputText type="text" class="w-full" [value]="getFabricCodeIssuedQuantity(pce.value.fabricCode) | number: '1.0-2'" [disabled]="true" />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input
                        pInputText
                        type="text"
                        class="w-full"
                        [value]="pce.value.quantity / 0.99 - getCurrentPlannedQuantity(pce.value.fabricCode) | number: '1.0-2'"
                        [disabled]="true"
                      />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>
                </tr>
              </ng-template>
            }
          </p-table>
        </p-card>
      </p-panel>
    } @else {
      <p-panel [header]="'Knitting_Order_Details_Items_Of_Production_Cards' | translateWF: 'Items of Production Cards'">
        <p-card data-variant="compact">
          <p-table [value]="groupedFabricForms" class="table w-full">
            <ng-template #header>
              <tr class="dark__header">
                <th class="text-center">{{ 'Knitting_Order_Details_Table_Fabric' | translateWF: 'Fabric' }}</th>
                <th class="text-center">
                  @if (isGreigeStockForDyeingOrder) {
                    <span
                      pTooltip="{{ 'Knitting_Order_Details_Tooltip_Greige_Dyeing_Planned_Qty' | translateWF: 'Work Order required Qty + Dyeing Loss %' }}"
                      tooltipPosition="top"
                    >
                      {{
                        'Knitting_Order_Details_Table_Greige_Dyeing_Planned_Qty'
                          | translateWF
                            : 'Estimated Qty with Dyeing
                  Loss'
                      }}
                      <i class="pi pi-info-circle ml-1 text-gray-400"></i>
                    </span>
                  } @else {
                    {{ 'Knitting_Order_Details_Table_Dyeing_Planned_Qty' | translateWF: 'Dyeing Planned Qty' }}
                  }
                </th>
                <th class="text-center">
                  <span
                    pTooltip="{{ 'Knitting_Order_Details_Tooltip_Greige_Estimated_Knitting_Qty' | translateWF: 'Estimated Qty with Dyeing Loss + Knitting Loss %' }}"
                    tooltipPosition="top"
                  >
                    {{
                      'Knitting_Order_Details_Table_Estimated_Knitting_Planning_Qty'
                        | translateWF
                          : 'Estimated Knitting
                  Planning Qty'
                    }}
                    <i class="pi pi-info-circle ml-1 text-gray-400"></i>
                  </span>
                </th>
                <th class="text-center">
                  {{ 'Knitting_Order_Details_Table_Planned_Qty' | translateWF: 'Planned Qty' }}
                </th>
                <th class="text-center">
                  {{ 'Knitting_Order_Details_Table_Programmed_Qty' | translateWF: 'Programmed Qty' }}
                </th>
                <th class="text-center">
                  {{ 'Knitting_Order_Details_Table_Issued_Qty' | translateWF: 'Issued Qty' }}
                </th>
                <th class="text-center">
                  {{ 'Knitting_Order_Details_Table_Missing_Qty' | translateWF: 'Missing Qty' }}
                </th>
              </tr>
            </ng-template>
            @if (groupedFabricForms.length > 0) {
              <ng-template #body let-fabric let-rowIndex="rowIndex">
                @let fabricStrict = groupFabricAsStrict(fabric);
                <tr>
                  <td>
                    <b>{{ fabricStrict.fabricCode }}</b>
                    <p>{{ fetchFabricDescription(fabricStrict.fabricCode) }} - {{ fetchFabricTubularOrOpenWith(fabricStrict.fabricCode) }}</p>
                    <b>Greige Code: {{ fetchGreigeCode(fabricStrict.fabricCode) }}</b>
                    <p>Needles: {{ fetchGreigeNeedleCount(fabricStrict.fabricCode) | number: '1.0-0' }}</p>
                    <p>Loop Length(s): {{ getFabricLoopLengths(fabricStrict.fabricCode) }}</p>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input
                        pInputText
                        type="text"
                        class="w-full"
                        [value]="getGreigeWorkOrderEstimatedWithDyeingLoss(fabricStrict.fabricCode) | number: '1.0-2'"
                        [disabled]="true"
                      />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  @if (isGreigeStockForDyeingOrder) {
                    <td>
                      <p-inputGroup>
                        <input
                          pInputText
                          type="text"
                          class="w-full"
                          [value]="getGreigeWorkOrderEstimatedWithDyeingLoss(fabricStrict.fabricCode) | number: '1.0-2'"
                          [disabled]="true"
                        />
                        <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                      </p-inputGroup>
                    </td>
                  }

                  <td>
                    <p-inputGroup>
                      <input
                        pInputText
                        type="text"
                        class="w-full"
                        [value]="getCurrentPlannedQuantity(fabricStrict.fabricCode) | number: '1.0-2'"
                        [readOnly]="true"
                        style="background-color: #ffedd5"
                      />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input pInputText type="text" class="w-full" [value]="getFabricCodeProgrammedQuantity(fabricStrict.fabricCode) | number: '1.0-2'" [disabled]="true" />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input pInputText type="text" class="w-full" [value]="getFabricCodeIssuedQuantity(fabricStrict.fabricCode) | number: '1.0-2'" [disabled]="true" />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>

                  <td>
                    <p-inputGroup>
                      <input
                        pInputText
                        type="text"
                        class="w-full"
                        [value]="getGreigeWorkOrderEstimatedWithKnittingLoss(fabricStrict.fabricCode) - getCurrentPlannedQuantity(fabricStrict.fabricCode) | number: '1.0-2'"
                        [disabled]="true"
                      />
                      <p-inputGroupAddon> {{ globalUnitMeasure }} </p-inputGroupAddon>
                    </p-inputGroup>
                  </td>
                </tr>
              </ng-template>
            }
          </p-table>
        </p-card>
      </p-panel>
    }

    @if (workOrder.value && workOrder.value.fabrics.length > 0) {
      <p-selectbutton [options]="section" optionLabel="label" optionValue="value" [formControl]="selectedSection" />

      @switch (selectedSection.value) {
        @case (1) {
          <p-panel [header]="'Knitting_Order_Details_Fabrics' | translateWF: 'Fabrics'">
            <!-- knitting-order-details.component.html -->
            <div class="work-order-details">
              <div class="grid-4">
                <!-- Autocomplete para agregar -->
                <div class="span-4">
                  <p-card>
                    <div class="row-between-center">
                      <div class="form-box">
                        <p-autoComplete
                          [dropdown]="true"
                          [formControl]="workOrderFabricSearch"
                          (completeMethod)="workOrderFabricTypeahead($event)"
                          [suggestions]="workOrderFabricOptions"
                          optionLabel="fieldToDisplay"
                          styleClass="w-full"
                        ></p-autoComplete>
                      </div>

                      <p-selectButton [formControl]="displayModeControl" [options]="viewModeOptions" optionLabel="label" optionValue="value" class="inline-flex">
                        <ng-template let-option pTemplate="item">
                          @if (option.value === 'grouped') {
                            <i class="text-lg pi pi-th-large"></i>
                          } @else {
                            <i class="text-lg pi pi-list"></i>
                          }
                        </ng-template>
                      </p-selectButton>
                    </div>
                  </p-card>
                </div>

                <!-- !VISTA AGRUPADA -->
                <div class="span-4" *ngIf="displayModeControl.value === 'grouped'">
                  <p-panel data-tone="surface" [header]="'Knitting_Order_Details_Work_Orders_Fabric' | translateWF: 'Work Order Fabrics'">
                    <ng-container *ngIf="groupedFabricForms.length > 0; else noFabrics">
                      <div class="col-sm">
                        <ng-container *ngFor="let group of groupedFabricForms; let gi = index">
                          <p-panel [toggleable]="true">
                            <ng-template pTemplate="header">
                              <div class="flex justify-between items-center w-full">
                                <div>
                                  <h4>{{ group.fabricCode }}</h4>
                                  <p>{{ fetchFabricDescription(group.fabricCode) }}</p>
                                </div>

                                <p-button
                                  variant="text"
                                  icon="pi pi-trash"
                                  title="Delete all variants for {{ group.fabricCode }}"
                                  (click)="deleteFabricGroupGroup(gi); $event.stopPropagation()"
                                  [disabled]="blockSections()"
                                />
                              </div>
                            </ng-template>

                            <p-card data-variant="compact">
                              <!-- Selector de variante dentro del grupo -->
                              <div class="flex gap-3 mb-[1rem] overflow-hidden">
                                <p-selectButton
                                  [formControl]="group.variantControl"
                                  [options]="group.variantOptions"
                                  optionLabel="label"
                                  optionValue="value"
                                  class="rounded-none p-0"
                                  styleClass="text-sm"
                                ></p-selectButton>

                                <p-button variant="text" icon="pi pi-plus" (click)="addVariantToGroup(group.fabricCode)" [disabled]="blockSections()" />
                              </div>

                              <!-- Mostrar solo la variante seleccionada -->
                              <ng-container *ngIf="group.groups[group.variantControl.value] as formGroup">
                                <div [formGroup]="formGroup" class="child__card">
                                  <div class="flex">
                                    <div class="form-box mt-2 mb-4 ml-4 max-w-[12rem]">
                                      <label>
                                        {{ 'Knitting_Order_Details_Fabric_Quantity' | translateWF: 'Fabric Quantity' }}
                                      </label>
                                      <p-inputGroup>
                                        <p-inputNumber
                                          formControlName="quantity"
                                          type="number"
                                          class="w-full"
                                          [minFractionDigits]="2"
                                          [maxFractionDigits]="2"
                                          [ngClass]="{
                                            'ng-invalid': invalidInputs() || (formGroup.get('quantity')?.invalid && formGroup.get('quantity')?.touched),
                                            'ng-dirty': invalidInputs() || (formGroup.get('quantity')?.invalid && formGroup.get('quantity')?.touched),
                                          }"
                                        ></p-inputNumber>
                                        <p-inputGroupAddon>Lbs</p-inputGroupAddon>
                                      </p-inputGroup>
                                    </div>

                                    <div class="flex justify-end w-full">
                                      <p-button
                                        type="button"
                                        icon="pi pi-trash"
                                        title="Delete variant"
                                        variant="outlined"
                                        [disabled]="blockSections()"
                                        (click)="deleteVariant(formGroup.value.fabric!.fabricCode, group.variantControl.value)"
                                      />
                                    </div>
                                  </div>

                                  <p-table [value]="getYarnAndProviderInfosControls(formGroup)" class="table w-full">
                                    <ng-template pTemplate="header">
                                      <tr>
                                        <th>
                                          {{ 'Knitting_Order_Details_Yarn_Item_Code' | translateWF: 'Yarn Item Code' }}
                                        </th>
                                        <th style="width: 100px">
                                          {{ 'Knitting_Order_Details_Percentage' | translateWF: 'Percentage' }}
                                        </th>
                                        <th>
                                          {{ 'Knitting_Order_Details_Quantity' | translateWF: 'Quantity' }}
                                        </th>
                                        <th>{{ 'Knitting_Order_Details_Manufacturer' | translateWF: 'Manufacturer' }}</th>
                                        <th>
                                          {{
                                            'Knitting_Order_Details_Manufacturer_Lot_Id'
                                              | translateWF
                                                : 'Manufacturer Lot
                                    Number'
                                          }}
                                        </th>
                                      </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                                      <tr [formGroup]="row">
                                        <td>
                                          <strong> ({{ getYarnCodeItemMasterCode(buildUniqueKey(row.value.yarn?.code, workOrder.value.id, group.fabricCode)) }})</strong>
                                          ({{ row.value.yarn?.code }})
                                          {{ row.value.yarn?.longDescription }}
                                        </td>
                                        <td>{{ getYarnPercentage(row.value.yarn?.code, formGroup.value.fabric!) }}%</td>
                                        <td>
                                          <input
                                            pInputText
                                            type="text"
                                            class="w-full"
                                            [value]="(getYarnPercentage(row.value.yarn?.code, formGroup.value.fabric!) * formGroup.get('quantity')!.value) / 100 | number: '1.0-2'"
                                            disabled
                                          />
                                        </td>
                                        <td>
                                          <p-autoComplete
                                            [panelStyle]="{ 'z-index': '1100' }"
                                            formControlName="provider"
                                            #manufacturerSearch1="cslServerSearch"
                                            [cslServerSearch]="fetchManufacturers"
                                            [suggestions]="manufacturerSearch1.results()"
                                            dropdownIcon="pi pi-search"
                                            [placeholder]="'Knitting_Order_Details_Search_Manufacturer' | translateWF: 'Search Manufacturer'"
                                            optionLabel="fieldToDisplay"
                                            class="w-full"
                                            [dropdown]="true"
                                            [forceSelection]="true"
                                            appendTo="body"
                                          >
                                            <ng-template let-provider pTemplate="item">
                                              <div class="panel__option" [title]="provider.fieldToDisplay">
                                                {{ provider.fieldToDisplay }}
                                              </div>
                                            </ng-template>
                                          </p-autoComplete>
                                        </td>
                                        <td>
                                          <ng-container *ngIf="row.controls.provider.value?.lotNumbers?.length > 0; else noLots">
                                            <p-select
                                              formControlName="providerLotNumber"
                                              [options]="row.controls.provider.value.lotNumbers"
                                              [filter]="true"
                                              [showClear]="true"
                                              class="w-full"
                                              appendTo="body"
                                            ></p-select>
                                          </ng-container>
                                          <ng-template #noLots>
                                            <p>
                                              {{
                                                'Knitting_Order_Details_No_Lots_Msg'
                                                  | translateWF
                                                    : 'No lots for this
                                        manufacturer'
                                              }}
                                            </p>
                                          </ng-template>
                                        </td>
                                      </tr>
                                    </ng-template>
                                  </p-table>
                                </div>
                              </ng-container>
                            </p-card>
                          </p-panel>
                        </ng-container>
                      </div>
                    </ng-container>
                  </p-panel>
                </div>

                <!-- !VIEW FOR PESELCTBUTTON -->
                <div class="span-4" *ngIf="displayModeControl.value === 'flat'">
                  <p-panel data-tone="surface" [header]="'Knitting_Order_Details_Work_Orders_Fabric' | translateWF: 'Work Order Fabrics'">
                    <ng-container *ngIf="groupedFabricForms.length > 0; else noFabrics">
                      <ng-container *ngFor="let group of groupedFabricForms; let gi = index; trackBy: trackByFabricCode">
                        <p-panel [toggleable]="true">
                          <ng-template pTemplate="header">
                            <div class="flex justify-between items-center w-full">
                              <h4>{{ group.fabricCode }}</h4>
                              <p-button
                                variant="text"
                                icon="pi pi-trash"
                                title="Delete all variants for {{ group.fabricCode }}"
                                (onClick)="deleteFabricGroupGroup(gi); $event.stopPropagation()"
                              />
                            </div>
                          </ng-template>

                          <p-card data-variant="compact">
                            <ng-container *ngFor="let formGroup of group.groups; let vi = index">
                              <div [formGroup]="formGroup" class="child__card">
                                <div class="flex">
                                  <p-tag>{{ formGroup.value.variantCode }}</p-tag>
                                  <div class="form-box mb-4 ml-4">
                                    <label>
                                      {{ 'Knitting_Order_Details_Production_Card' | translateWF: 'Production Card' }}
                                    </label>
                                    <p-autocomplete
                                      class="w-full"
                                      formControlName="productionCardReference"
                                      [dropdown]="true"
                                      [suggestions]="productionCardsToDisplay"
                                      optionLabel="productionCardNumber"
                                      optionValue="id"
                                      [placeholder]="'Knitting_Order_Details_Select_Production_Card' | translateWF: 'Select Production Card'"
                                      appendTo="body"
                                      (completeMethod)="searchProductionCards($event, group.fabricCode)"
                                    />
                                  </div>

                                  <div class="flex justify-end w-full">
                                    <p-button
                                      type="button"
                                      icon="pi pi-trash"
                                      title="Delete variant"
                                      variant="outlined"
                                      [disabled]="blockSections()"
                                      (click)="deleteVariant(formGroup.value.fabric!.fabricCode, group.variantControl.value)"
                                    />
                                  </div>
                                </div>

                                <div class="form-box mt-2 mb-4 max-w-[12rem]">
                                  <label>
                                    {{ 'Knitting_Order_Details_Fabric_Quantity' | translateWF: 'Fabric Quantity' }}
                                  </label>
                                  <p-inputGroup>
                                    <p-inputNumber
                                      formControlName="quantity"
                                      type="number"
                                      class="w-full"
                                      [minFractionDigits]="2"
                                      [maxFractionDigits]="2"
                                      [ngClass]="{
                                        'ng-invalid': invalidInputs() || (formGroup.get('quantity')?.invalid && formGroup.get('quantity')?.touched),
                                        'ng-dirty': invalidInputs() || (formGroup.get('quantity')?.invalid && formGroup.get('quantity')?.touched),
                                      }"
                                    ></p-inputNumber>
                                    <p-inputGroupAddon>{{ globalUnitMeasure }}</p-inputGroupAddon>
                                  </p-inputGroup>
                                </div>

                                <p-table [value]="getYarnAndProviderInfosControls(formGroup)" class="table w-full">
                                  <ng-template pTemplate="header">
                                    <tr>
                                      <th>
                                        {{ 'Knitting_Order_Details_Yarn_Item_Code' | translateWF: 'Yarn Item Code' }}
                                      </th>
                                      <th style="width: 100px">
                                        {{ 'Knitting_Order_Details_Percentage' | translateWF: 'Percentage' }}
                                      </th>
                                      <th>
                                        {{ 'Knitting_Order_Details_Quantity' | translateWF: 'Quantity' }}
                                      </th>
                                      <th>{{ 'Knitting_Order_Details_Manufacturer' | translateWF: 'Manufacturer' }}</th>
                                      <th>
                                        {{
                                          'Knitting_Order_Details_Manufacturer_Lot_Id'
                                            | translateWF
                                              : 'Manufacturer Lot
                                  Number'
                                        }}
                                      </th>
                                    </tr>
                                  </ng-template>
                                  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                                    <tr [formGroup]="row">
                                      <td>
                                        <strong> ({{ getYarnCodeItemMasterCode(buildUniqueKey(row.value.yarn?.code, workOrder.value.id, group.fabricCode)) }})</strong>
                                        ({{ row.value.yarn?.code }})
                                        {{ row.value.yarn?.longDescription }}
                                      </td>
                                      <td>{{ getYarnPercentage(row.value.yarn?.code, formGroup.value.fabric!) }}%</td>
                                      <td>
                                        <input
                                          pInputText
                                          type="text"
                                          class="w-full"
                                          [value]="(getYarnPercentage(row.value.yarn?.code, formGroup.value.fabric!) * formGroup.get('quantity')!.value) / 100 | number: '1.0-2'"
                                          disabled
                                        />
                                      </td>
                                      <td>
                                        <p-autoComplete
                                          [panelStyle]="{ 'z-index': '1100' }"
                                          formControlName="provider"
                                          #manufacturerSearch2="cslServerSearch"
                                          [cslServerSearch]="fetchManufacturers"
                                          [suggestions]="manufacturerSearch2.results()"
                                          dropdownIcon="pi pi-search"
                                          [placeholder]="'Knitting_Order_Details_Search_Manufacturer' | translateWF: 'Search Manufacturer'"
                                          optionLabel="fieldToDisplay"
                                          class="w-full"
                                          [dropdown]="true"
                                          [forceSelection]="true"
                                          appendTo="body"
                                        >
                                          <ng-template let-provider pTemplate="item">
                                            <div class="panel__option" [title]="provider.fieldToDisplay">
                                              {{ provider.fieldToDisplay }}
                                            </div>
                                          </ng-template>
                                        </p-autoComplete>
                                      </td>

                                      <td>
                                        <ng-container *ngIf="row.controls.provider.value?.lotNumbers?.length > 0; else noLots">
                                          <p-select
                                            formControlName="providerLotNumber"
                                            [options]="row.controls.provider.value.lotNumbers"
                                            [filter]="true"
                                            [showClear]="true"
                                            class="w-full"
                                            appendTo="body"
                                          ></p-select>
                                        </ng-container>
                                        <ng-template #noLots>
                                          <p>
                                            {{
                                              'Knitting_Order_Details_No_Lots_Msg'
                                                | translateWF
                                                  : 'No lots for this
                                      manufacturer'
                                            }}
                                          </p>
                                        </ng-template>
                                      </td>
                                    </tr>
                                  </ng-template>
                                </p-table>
                              </div>
                            </ng-container>

                            <div class="p-4 text-right">
                              <button
                                pButton
                                type="button"
                                icon="pi pi-plus"
                                [label]="'Knitting_Order_Details_Add_Entry' | translateWF: 'Add Entry'"
                                class="p-button-sm"
                                (click)="addVariantToGroup(group.fabricCode)"
                                [disabled]="blockSections()"
                              ></button>
                            </div>
                          </p-card>
                        </p-panel>
                      </ng-container>
                    </ng-container>
                  </p-panel>
                </div>
              </div>

              <ng-template #noFabrics>
                <p-message severity="secondary" [text]="'Knitting_Order_Details_No_Work_Orders_Fabrics_Added' | translateWF: 'No work orders fabrics added'" />
              </ng-template>
            </div>
          </p-panel>
        }
        @case (2) {
          @if (!originalKnittingOrder) {
            <p>
              {{ 'Knitting_Order_Details_Rolls_Msg' | translateWF: 'Save Knitting Order Before Creating Rolls' }}
            </p>
          } @else {
            <p-panel [header]="'Knitting_Order_Details_Rolls_Knitting_Machines' | translateWF: 'Knitting Machines'">
              <p-card data-variant="compact">
                <div class="col">
                  <p-panel>
                    <p-card>
                      <div class="grid-5 items-end content-center" [formGroup]="machineProgrammingToolFormGroup">
                        <div class="span-1">
                          <div class="form-box">
                            <label class="font-semibold">
                              {{ 'Knitting_Order_Details_Rolls_Fabric_Variant' | translateWF: 'Fabric Variant' }}
                            </label>
                            <p-autocomplete
                              [dropdown]="true"
                              dropdownIcon="pi pi-search"
                              [group]="true"
                              formControlName="fabricAndVariantCode"
                              (completeMethod)="fabricVariantTypeahead()"
                              [suggestions]="fabricVariantOptions"
                              (onSelect)="filteredAssetByFabricSelection()"
                              [forceSelection]="true"
                              [fluid]="true"
                              class="w-full"
                              [ngClass]="{
                                'ng-invalid ng-dirty': attempedToProgramMachines && machineProgrammingToolFormGroup.controls['fabricAndVariantCode'].invalid,
                              }"
                            >
                              <ng-template let-group #group>
                                <div class="flex items-center">
                                  <p>{{ group.label }}</p>
                                </div>
                              </ng-template>
                            </p-autocomplete>
                          </div>
                        </div>

                        <div class="span-1">
                          <div class="form-box">
                            <label class="font-semibold">
                              {{ 'Knitting_Order_Details_Rolls_Knitting_Machines' | translateWF: 'Knitting Machines' }}
                            </label>

                            <p-multiselect
                              formControlName="assets"
                              [options]="filteredAssets"
                              optionLabel="assetId"
                              [placeholder]="'selectMachine' | translateWF: 'Select a Machine'"
                              [fluid]="true"
                              class="w-full"
                              [filter]="true"
                              filterBy="assetId"
                              (onFilter)="onMachineFilterChange($event)"
                              [ngClass]="{
                                'ng-invalid ng-dirty': attempedToProgramMachines && machineProgrammingToolFormGroup.controls['assets'].invalid,
                              }"
                            >
                              <ng-template let-option pTemplate="item"> {{ option.assetId }} - {{ option.description }} </ng-template>
                            </p-multiselect>
                          </div>
                        </div>

                        <div class="span-1">
                          <div class="form-box">
                            <label class="font-semibold">
                              {{ 'Knitting_Order_Details_Rolls_Qty_Be_To_Knitting' | translateWF: 'Quantity to be Knitting' }}
                            </label>
                            <p-inputgroup>
                              <p-input-number
                                type="number"
                                formControlName="quantityBeToKnitting"
                                pInputNumber
                                mode="decimal"
                                [minFractionDigits]="2"
                                fluid
                                class="w-full"
                                [ngClass]="{
                                  'ng-invalid ng-dirty': attempedToProgramMachines && machineProgrammingToolFormGroup.controls['quantityBeToKnitting'].invalid,
                                }"
                              />
                              <p-inputGroupAddon> Lb(s) </p-inputGroupAddon>
                            </p-inputgroup>
                          </div>
                        </div>

                        <div class="span-1">
                          <div class="form-box">
                            <label class="font-semibold">
                              {{ 'Knitting_Order_Details_Rolls_Lbs_Per_Roll' | translateWF: 'Lbs per Roll' }}
                            </label>
                            <p-inputgroup>
                              <p-input-number
                                type="number"
                                [formControl]="lbsPerRollControl"
                                [min]="0"
                                pInputNumber
                                fluid
                                class="w-full"
                                [ngClass]="{
                                  'ng-invalid ng-dirty': attempedToProgramMachines && lbsPerRollControl.invalid,
                                }"
                              />
                              <p-inputGroupAddon> Lb(s) </p-inputGroupAddon>
                            </p-inputgroup>
                          </div>
                        </div>

                        <div class="span-1">
                          <p-button
                            class="btn-generate-programming w-full text-xl"
                            fluid
                            class="w-full"
                            [label]="'Knitting_Order_Details_Rolls_Generate_Rolls' | translateWF: 'Generate Rolls'"
                            (click)="programMachinesWithTool()"
                          />
                        </div>
                      </div>
                    </p-card>
                  </p-panel>

                  <p-panel>
                    <p-card>
                      <div class="flex items-center px-1 py-0.5">
                        <div class="flex gap-6 text-gray-700">
                          <div class="flex flex-col items-start">
                            <span class="text-xs font-medium">
                              {{ 'Knitting_Order_Details_Rolls_Created' | translateWF: 'Rolls Created' }}
                            </span>
                            <span class="text-base font-semibold">{{ totalRollCount }}</span>
                          </div>
                          <div class="flex flex-col items-start">
                            <span class="text-xs font-medium">
                              {{ 'Knitting_Order_Details_Rolls_Printed' | translateWF: 'Rolls Printed' }}
                            </span>
                            <span class="text-base font-semibold">{{ printedRollCount }}</span>
                          </div>
                          <div class="flex flex-col items-start">
                            <span class="text-xs font-medium">
                              {{ 'Knitting_Order_Details_Rolls_Completed' | translateWF: 'Rolls Completed' }}
                            </span>
                            <span class="text-base font-semibold">0</span>
                          </div>
                        </div>
                      </div>
                    </p-card>
                  </p-panel>
                </div>

                <div class="row-start-center" [class.mb-3]="selectedCombos.length > 0">
                  @if (selectedCombos.length > 0) {
                    <p-button [label]="printSelectedKmInstructionsLabel" icon="pi pi-print" styleClass="p-button-sm" (click)="printSelectedKmInstructions()" />
                  }
                </div>

                <p-table [value]="knittingMachineCombos" dataKey="asset.assetId" class="table w-full">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 3rem">
                        <p-checkbox [formControl]="selectAllControl" [binary]="true" styleClass="p-checkbox-sm" />
                      </th>
                      <th style="width: 7%">
                        {{ 'Knitting_Order_Details_Rolls_Table_Knitting_Machine' | translateWF: 'Knitting Machine' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Km_Instructions' | translateWF: 'KM Instructions' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Fabric_Code' | translateWF: 'Fabric Code' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Fabric' | translateWF: 'Fabric' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Loop_Length' | translateWF: 'Loop Length(s)' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Variant_Code' | translateWF: 'Variant Code' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Manufacture_And_Lot' | translateWF: 'Manufacturer and Lot' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Programmed' | translateWF: 'Programmed (Lbs)' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Roll_Count' | translateWF: 'Roll Count' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Issued_Rolls' | translateWF: 'Issued Rolls' }}
                      </th>
                      <th>
                        {{ 'Knitting_Order_Details_Rolls_Table_Issued_Weight' | translateWF: 'Issued Weight (Lbs)' }}
                      </th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-rollCombo>
                    <tr>
                      <td>
                        <p-checkbox [formControl]="selectionControl" [value]="comboKey(rollCombo)" styleClass="p-checkbox-sm" />
                      </td>
                      <td>{{ rollCombo.asset.assetId }}</td>
                      <td>
                        <button
                          type="button"
                          class="border-none"
                          title="{{ 'Print_Km_Instructions' | translateWF: 'Print KM Instructions' }}"
                          (click)="printKmInstructions(rollCombo)"
                        >
                          <span class="pi pi-print"></span>
                        </button>
                      </td>
                      <td>{{ rollCombo.fabric.fabricCode }}</td>
                      <td>{{ rollCombo.fabric.longDescription }}</td>
                      <td>{{ getFabricLoopLengths(rollCombo.fabric.fabricCode) }}</td>
                      <td>{{ rollCombo.variantCode }}</td>
                      <td>
                        @for (item of getManufactureAndLotsData(rollCombo); track $index) {
                          <p class="mt-2">{{ item.provider }} - {{ item.lotItem }}</p>
                        }
                      </td>
                      <td>{{ getQuantityToKnit(rollCombo) | number: '1.2-2' }}</td>
                      <td>{{ rollCombo.savedRolls.length }}</td>
                      <td>{{ getIssuedRollsCount(rollCombo) | number: '1.2-2' }}</td>
                      <td>{{ getIssuedRollsWeight(rollCombo) | number: '1.2-2' }}</td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="footer">
                    <tr class="font-bold border-t border-gray-300">
                      <td colspan="8" class="text-right">
                        <div class="flex items-center justify-end gap-3">
                          <span>Total:</span>
                        </div>
                      </td>

                      <td>
                        {{ totalPlannedQuantityToKnit | number: '1.0-2' }}
                      </td>
                      <td>
                        {{ totalRollCount | number: '1.0-2' }}
                      </td>
                      <td>{{ totalIssuedRollsCount }}</td>
                      <td>{{ totalIssuedWeight | number: '1.2-2' }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-card>
            </p-panel>

            @if (selectedComboKeys.size > 0) {
              <app-sidebar-knitting-programming [selectedComboKeys]="selectedComboKeys" (closeModal)="clearAllCombos()" />
            }
          }
        }
      }
    }
  </div>
</main>
